import { SocketioService } from './socketio.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModulomxService {

  constructor(
    public socketioService: SocketioService
  ) { }


  mensajesolicitudlicencias(cliente: string, mensaje: string) {
    const payload = {
      de: cliente,
      cuerpo : mensaje
    };

    this.socketioService.emit ('solicitalicencia', payload);
  }

  mensajeadquierelicencias(cliente: string, mensaje: string) {
    const payload = {
      de: cliente,
      cuerpo : mensaje
    };
    
// console.log ('adquierelicencias');
    this.socketioService.emit ('adquierelicencias', payload);

  }


  compralicencias(cliente: string, mensaje: string) {
    const payload = {
      de: cliente,
      cuerpo : mensaje
    };

    this.socketioService.emit ('compralicencias', payload);
  }


  escuchasolicitudenviada(nombreEvento: string) {
    return this.socketioService.listen (nombreEvento);
  }



}
